import React from 'react'
import { MediumContainer } from 'component/Layout'

export const CreditsPage = () =>
	<MediumContainer>
		<h3>Credits</h3>
	</MediumContainer>